import React from 'react'
import { Link } from 'react-router-dom'

const AdminDashboard: React.FC = () => {
  return (
    <div className="card">
      <div className="card-header">
        <div>
          <h1 className="card-title">Backoffice</h1>
          <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
            Gestion des services, options, prises en charge, livraisons et commandes.
          </p>
        </div>
        <span className="badge">Admin</span>
      </div>

      <div className="grid-2">
        <Link to="/admin/services" className="card">
          <div className="card-header">
            <div className="card-title">Services & tarifs</div>
          </div>
          <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
            Ajouter / modifier les services (tennis, badminton) et leurs prix, suivre l&apos;historique des
            modifications.
          </p>
        </Link>
        <Link to="/admin/transport" className="card">
          <div className="card-header">
            <div className="card-title">Prises en charge & livraisons</div>
          </div>
          <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
            Configurer les dépôts à l&apos;atelier et les livraisons à domicile, avec facturation au km.
          </p>
        </Link>
        <Link to="/admin/orders" className="card">
          <div className="card-header">
            <div className="card-title">Commandes</div>
          </div>
          <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
            Visualiser les commandes, changer leurs statuts et suivre les livraisons.
          </p>
        </Link>
        <Link to="/admin/slots" className="card">
          <div className="card-header">
            <div className="card-title">Créneaux de livraison</div>
          </div>
          <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
            Définir tes disponibilités : 17h–23h en semaine, après-midi le week-end.
          </p>
        </Link>
        <Link to="/admin/partners" className="card" data-testid="admin-partners-card">
          <div className="card-header">
            <div className="card-title">Partenaires</div>
          </div>
          <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
            Gérer les clubs et associations partenaires, leurs coupons et leurs comptes.
          </p>
        </Link>
      </div>
    </div>
  )
}

export default AdminDashboard
